export default class MediaLibrarySearchPagination
{
    constructor()
    {
        // Elements
        this.paginationWrapper = document.querySelector('.js-media-library__pagination--container');
        this.paginationFirst = document.querySelector('.js-media-library__paginaton--first');
        this.paginationPrev = document.querySelector('.js-media-library__paginaton--prev');
        this.paginationNumbersWrapper = document.querySelector('.js-media-library__paginaton--numbers-container');
        this.paginationNumberTemplate = document.querySelector('.js-media-library__paginaton--number-template');
        this.paginationNext = document.querySelector('.js-media-library__paginaton--next');
        this.paginationLast = document.querySelector('.js-media-library__paginaton--last');

        // Selectors
        this.paginationNumberSelector = ('.js-media-library__paginaton--number');

        // Helpers
        this.isInitialized = false;
        this.assetsPerPage = 30;
        this.totalAssets = 0;
        this.totalPages = 0;
        this.currentPage = 0;
    }

    /**
	 * @callback fetchAssets fetch assets
	 * @param {number} assetsPerPage page limit
	 * @param {number} skipAssets starting point
	 * @param {boolean} isPagination is pagination
	 */

    /**
	 * @param {fetchAssets} fetchAssets callback
	 * @param {number} totalItems total hits
	 * @param {number} skipAssets skipped assets
	 */
    init(fetchAssets, totalItems, skipAssets = 0)
    {
        this.paginationNumbersWrapper.innerHTML = '';

        this.totalAssets = totalItems;

        if (this.totalAssets > this.assetsPerPage)
        {
            let selectedPage = skipAssets / this.assetsPerPage + 1;
            let totalPages = Math.ceil(this.totalAssets / this.assetsPerPage);
            let pageNumber = selectedPage <= totalPages ? selectedPage : 1;

            this.createPagination(fetchAssets);
            this.handlePaginationChange(pageNumber);
            this.paginationWrapper.classList.remove('hidden');
        }
        else
        {
            this.paginationWrapper.classList.add('hidden');
        }

        if (!this.isInitialized)
        {
            this.initEvents(fetchAssets);
            this.isInitialized = true;
        }
    }

    /**
	 * @param {fetchAssets} fetchAssets callback
	 */
    initEvents(fetchAssets)
    {
        this.paginationFirst.querySelector('a').addEventListener('click', () =>
        {
            let skip = 0;
            let size = this.assetsPerPage;

            this.handlePaginationChange(1);
            fetchAssets(size, skip, true);
        });

        this.paginationPrev.querySelector('a').addEventListener('click', () =>
        {
            let skip = (this.currentPage - 2) * this.assetsPerPage;
            let size = this.assetsPerPage;

            this.handlePaginationChange(this.currentPage - 1);
            fetchAssets(size, skip, true);
        });

        this.paginationNext.querySelector('a').addEventListener('click', () =>
        {
            let skip = (this.currentPage) * this.assetsPerPage;
            let size = (this.currentPage + 1) < this.totalPages ? this.assetsPerPage : this.totalAssets - skip;

            this.handlePaginationChange(this.currentPage + 1);
            fetchAssets(size, skip, true);
        });

        this.paginationLast.querySelector('a').addEventListener('click', () =>
        {
            let skip = (this.totalPages - 1) * this.assetsPerPage;
            let size = this.totalAssets - skip;

            this.handlePaginationChange(this.totalPages);
            fetchAssets(size, skip, true);
        });
    }

    /**
	 * @param {fetchAssets} fetchAssets callback
	 */
    createPagination(fetchAssets)
    {
        this.totalPages = Math.ceil(this.totalAssets / this.assetsPerPage);

        this.currentPage = 1;

        for (let page = 1; page <= this.totalPages; page++)
        {
            this.createPaginationNumber(fetchAssets, page);
        }

        this.handlePaginationOverflow(1);
    }

    /**
	 * @param {fetchAssets} fetchAssets function to fetch assets
     * @param {number} page current page
	 */
    createPaginationNumber(fetchAssets, page)
    {
        let clone = this.paginationNumberTemplate.cloneNode(true);
        let skip = (page - 1) * this.assetsPerPage;

        if (page === 1)
        {
            clone.classList.add('current');
        }

        clone.querySelector('a').innerText = page;

        clone.classList.add('js-media-library__paginaton--number-' + page);

        clone.querySelector('a').addEventListener('click', () =>
        {
            this.handlePaginationChange(page);

            if (page === this.totalPages)
            {
                fetchAssets(this.totalAssets - skip, skip, true);
            }
            else
            {
                fetchAssets(this.assetsPerPage, skip, true);
            }
        });

        clone.classList.remove('hidden');

        this.paginationNumbersWrapper.append(clone);
    }

    /**
	 * @param {number} page current page
	 */
    handlePaginationOverflow(page)
    {
        let numbers = this.paginationWrapper.querySelectorAll(this.paginationNumberSelector);
        let skips = this.paginationWrapper.querySelectorAll('.skipped');

        numbers.forEach(number =>
        {
            number.classList.remove('hidden');
        });

        skips.forEach(skip =>
        {
            skip.remove();
        });

        if (this.totalPages > 8)
        {
            this.createSkipElement(page);
        }
    }

    /**
	 * @param {number} page current page
	 */
    createSkipElement(page)
    {
        let skip = document.createElement('li');

        skip.classList.add('skipped');
        skip.innerText = '...';

        if (page > 4)
        {
            let clone = skip.cloneNode(true);
            let first = this.paginationWrapper.querySelector(this.paginationNumberSelector + '-1');

            for (let i = 2; i < page - 2 && i < this.totalPages - 5; i++)
            {
                this.paginationWrapper
                    .querySelector(this.paginationNumberSelector + '-' + i)
                    .classList
                    .add('hidden');
            }

            first.after(clone);
        }

        if (page < this.totalPages - 3)
        {
            let clone = skip.cloneNode(true);
            let last = this.paginationWrapper.querySelector(this.paginationNumberSelector + '-' + this.totalPages);

            for (let i = this.totalPages - 1; i > page + 2 && i > 6; i--)
            {
                this.paginationWrapper
                    .querySelector(this.paginationNumberSelector + '-' + i)
                    .classList
                    .add('hidden');
            }

            last.before(clone);
        }
    }

    /**
	 * @param {number} page current page
	 */
    handlePaginationChange(page)
    {
        this.currentPage = page;

        this.paginationWrapper.querySelector(this.paginationNumberSelector + '.current').classList.remove('current');
        this.paginationWrapper.querySelector(this.paginationNumberSelector + '-' + page).classList.add('current');

        this.handlePaginationOverflow(page);

        if (page === 1)
        {
            this.paginationFirst.classList.add('disabled');
            this.paginationPrev.classList.add('disabled');
        }
        else
        {
            this.paginationFirst.classList.remove('disabled');
            this.paginationPrev.classList.remove('disabled');
        }

        if (page === this.totalPages)
        {
            this.paginationNext.classList.add('disabled');
            this.paginationLast.classList.add('disabled');
        }
        else
        {
            this.paginationNext.classList.remove('disabled');
            this.paginationLast.classList.remove('disabled');
        }

        setTimeout(() =>
        {
            window.scrollTo(0, 0);
        }, 0);
    }
}
